/*
 * @Descripttion: 排除
 * @Author: xutingting
 * @LastEditors: yang chenglin
 */
import React, { useState, useEffect, useContext } from 'react';
import { Input, Form, Select, Button, Radio, Balloon } from '@alifd/next';
import LzMsg from '@/components/common/LzMsg';
import { ActivityContext } from '../../../../Edit';
import UUID from '@/utils/UUID';
import nodes from '../../index';
import styles from '../../../index.module.scss';

export default ({ allNodeData = [], prevNodes = [], initData = {}, runState = {}, currentNode = {}, changeData = (data) => { }, onCancel = () => { }, validate = () => { }, getAllNodeIds = [] }) => {
    const { graph, nodeData } = useContext(ActivityContext);

    // 目标人群列表
    const [selectTargetList, setSelectTargetList] = useState([]);

    // 组件内部的数据
    const [data, setData] = useState({
        ...initData
    })

    /**
     * 选择目标人群，其余节点自动置为排除人群
     */
    const selectCrowd = (nameList, type = 'crowdName') => {
        const bufCorwdList = selectTargetList.filter((item) => {
            return item !== nameList
        })
        // 如果type为crowdName，则excludedNames值bufCorwdList，如果为excludedNames，则crowdName值为bufCorwdList
        if (type === 'crowdName') {
            onChange({ crowdName: [nameList], excludedNames: bufCorwdList })
        } else {
            onChange({ crowdName: bufCorwdList, excludedNames: [nameList] })
        }
    }
    /**
     * 合并新旧状态
     */
    const onChange = (newData) => {
        setData({
            ...data,
            ...newData,
        })
    }

    /**
     * 拖拽结束事件(模拟调用拖拽方法，并没有真正拖拽节点，这里是批量生成出来的抽取节点)
     */
    const dragStop = (event, node, item, index) => {
        // 移除document上的事件绑定
        document.onmousemove = null;
        document.onmouseup = null;
        document.onmouseleave = null;
        const nodeId = UUID.getUUID32();
        // 在节点数据中添加节点信息，
        nodeData.push({
        nodeId,
        ...node.create(),
        });
        const batchNodeX = graph.getNodeById(currentNode.nodeId)?._cfg?.model?.x;
        const batchNodeY = graph.getNodeById(currentNode.nodeId)?._cfg?.model?.y;
        const point = graph.getClientByPoint(batchNodeX, batchNodeY); // 将渲染坐标转换为屏幕/页面坐标
        graph.addNode(nodeId, node, point.x + 250*(Math.ceil((index+1)/5)), point.y + 100*((index)%5));
        try {
        // 赋值节点信息
        const createNode = nodeData.filter((node) => node.nodeId === nodeId)[0];
        createNode.data.name = `人群抽取-${item.length >= 24 ? item.substring(item.length - 5) : item}`;
        createNode.data.preActName = data.name;
        createNode.data.extractType = item;
        createNode.data.preResourceType = 'CROWD_DIFFERENCE';
        // 给节点名称赋值
        graph.updateItem(nodeId, {
            label: createNode.data.name,
            targetCrowd: createNode.data.extractType
        });
        // 连接当前去重节点和新生成的人群抽取节点
        graph.addEdge(
            UUID.getUUID32(),
            currentNode.nodeId,
            createNode.nodeId
        );
        } catch (e) {
        console.log(e);
        }
    };

    /**
     * 点击确认
     */
    const confirm = async () => {
        try {
            await Promise.all(Object.keys(validate).map(async validator => {
                // 最终校验数据是否填写完整，然后提交给全局
                try {
                    if (validator in data) {
                        if (validator === 'name') {
                            await validate[validator](data[validator], allNodeData, currentNode, getAllNodeIds);
                        } else {
                            await validate[validator](data[validator]);
                        }
                    }
                } catch (e) {
                    throw new Error(e);
                }
            }));
            changeData(data);
            data['crowdName'].map((x, index) => {
                dragStop(event, nodes.sourceNodes[2], x, index)
            })
            graph.updateItem(currentNode.nodeId, {
                targetCrowd: data.crowdName.join(','),
                differenceType: data.differenceType
            });
        } catch (e) {
            LzMsg.error(e.message);
        }
    };

    /**
     * 点击退出
     */
    const cancel = () => {
        onCancel()
    }

    const handleData = () => {
        const bufCrowdList = prevNodes.map((item) => {
            if (item.info.name === 'CROWD_EXTRACT') { // 前置节点是抽取节点，必须是抽取出来的那个人群包
              return item.data.extractType
            } else {
              const realCheckName = ['CROWD_DIG', 'CROWD_DIG_BATCH'].indexOf(item.info.name) > -1 ? item.data.crowdName : item.data.name;
              return realCheckName;
            }
          })
          setSelectTargetList(bufCrowdList);
    }
  /**
   * 打开弹窗判断是未填写内容还是已经填写完重新打开 未填写需判断是否有前置节点，获取上级节点赋值给目标人群列表，已填写就拿源数据直接初始化目标人群和排除人群
   */
  useEffect(() => {
    if(initData.crowdName.length > 0) { // 已经填写完，重新打开弹窗
      let selectArr = JSON.parse(JSON.stringify(initData.excludedNames)).concat(initData.crowdName);

      prevNodes.forEach((item) => {
        // 如果前置节点不是抽取节点并且填写的人群优先级组里没有这个节点的name，或者前置节点是抽取节点并且人群优先级组里没有抽取节点所抽出来的包名（或者短信节点的短信发送状态类型）
        // 这个是判断目前的前置节点信息和我之前填写时是否一致，如果不一致要修改，如果一致就可以直接读取
        const realCheckName = ['CROWD_DIG', 'CROWD_DIG_BATCH'].indexOf(item.info.name) > -1 ? item.data.crowdName : item.data.name;

        if((item.info.name !== 'CROWD_EXTRACT' && selectArr.indexOf(realCheckName) === -1) || (item.info.name === 'CROWD_EXTRACT' && selectArr.indexOf(item.data.extractType) === -1)) {
          onChange({ crowdName: [], excludedNames: [] }) // 如果下拉列表里没有包含这个节点名称，证明前置节点被修改了，把之前所填数据都清空
        }
      })
      handleData();
    } else { // 初次打开，直接拼出人群优先级组
      handleData();
    }
  }, [])

  const formItemLayout = {
    labelCol: {
      span: 5
    },
  };

  return (
    <div>
      <div style={{display: prevNodes.length >= 2 ? "none" : "block"}} className={styles['warning-text']}>{prevNodes.length ===1 ? '上级节点至少连接2个' : '请先连接上级节点'}</div>
      <Form className={`${styles.formDiv} ${styles.excludeDiv} canvasDialog`} {...formItemLayout}>

        <Form.Item label="排除方式：" required requiredMessage="请输入节点名称" style={{padding: '30px 15px 0 15px'}}>
            <Radio.Group
                value={data.differenceType}
                onChange={(differenceType) =>
                    onChange({ differenceType, excludedNames: [], crowdName: [] })
                }
            >
                <Radio id="1" value={1}>
                    1排N
                    <Balloon closable={false} align="t" trigger={<span style={{marginLeft: '5px'}} className='iconfont icon-icon4-33' />}>
                        <>
                            <div>1个人群排除多个人群，运算后生成1个人群；</div>
                            <div>选择该类型，排除节点的后置需要链接【人群抽取】节点</div>
                        </>
                    </Balloon>
                </Radio>
                <Radio id="2" value={2}>
                    N排1
                    <Balloon closable={false} align="t" trigger={<span style={{marginLeft: '5px'}} className='iconfont icon-icon4-33' />}>
                        <>
                            <div>N个人群分别排除一个人群，运算后生成N个人群；</div>
                            <div>选择该类型，排除节点的后置需要链接【人群抽取】节点</div>
                        </>
                    </Balloon>
                </Radio>
            </Radio.Group>
        </Form.Item>
        <Form.Item label="节点名称：" required requiredMessage="请输入节点名称" style={{padding: '0 15px'}}>
          <Input className={`formItemWidth`} name="excludeName" placeholder="请输入节点名称" trim size="small" value={data.name} onChange={(name) => onChange({ name })} showLimitHint maxLength={24}/>
        </Form.Item>
        {
            data.differenceType === 1 ? <>
                <Form.Item label="目标人群：" required requiredMessage="请选择目标人群" style={{padding: '0 15px'}}>
                    <Select size="small" className="formItemWidth search-input-ctrl1" value={data.crowdName.join(',')} onChange={(nameList) => selectCrowd(nameList, 'crowdName')} placeholder="请选择目标人群">
                        {
                        selectTargetList.map((r,index) => <Select.Option value={r} key={`crows${index}`}>{r}</Select.Option>)
                        }
                    </Select>
                </Form.Item>
                <Form.Item label="被排除人群：" required requiredMessage="请选择被排除人群" style={{padding: '0 15px'}}>
                    <Input.TextArea disabled className={`formItemWidth`} name="excludedNames" placeholder="" size="small" value={data.excludedNames}/>
                </Form.Item>
            </>
            : <>
                <Form.Item label="被排除人群：" required requiredMessage="请选择被排除人群" style={{padding: '0 15px'}}>
                    <Select size="small" className="formItemWidth search-input-ctrl1" value={data.excludedNames.join(',')} onChange={(nameList) => selectCrowd(nameList, 'excludedNames')} placeholder="请选择被排除人群">
                        {
                        selectTargetList.map((r,index) => <Select.Option value={r} key={`crows${index}`}>{r}</Select.Option>)
                        }
                    </Select>
                </Form.Item>
                <Form.Item label="目标人群：" required requiredMessage="请选择目标人群" style={{padding: '0 15px'}}>
                    <Input.TextArea disabled className={`formItemWidth`} name="crowdName" placeholder="" size="small" value={data.crowdName}/>
                </Form.Item>
            </>
        }
        <Form.Item label="备注：" style={{padding: '0 15px'}}>
          <Input.TextArea className={`formItemWidth`} name="remark" placeholder="请输入备注" size="small" trim value={data.remark} onChange={(remark) => onChange({ remark })} showLimitHint maxLength={150}/>
        </Form.Item>
        <hr />
        <div style={{padding: '15px 30px 0 0', height:'60px'}}>
          <Button type="primary" className={`submit-btn ${styles.w88}`} onClick={confirm} style={{float:'right'}}>确认</Button>
          <Button type="normal" className={`cancel-btn ${styles.mr10} ${styles.w88}`} onClick={cancel} style={{float:'right'}}>取消</Button>
        </div>
      </Form>
    </div>
  )
}
